import React from 'react';
import styled from 'styled-components';
import Box from '@clasohlson/co-ui-components/Box';

const StyledBox = styled(Box)`
  background: ${({ theme }) => theme.colors.lightGray};
  // border: ${({ theme }) => `1px solid ${theme.colors.mediumGray}`};
  height: 100%;
`;

export const BorderedBox = (props: any) => {
  return <StyledBox {...props} />;
};
